<template>
    <div>
        <h2 class="mb-3">
            <strong>Stock Information</strong>
        </h2>
        <div>Coming Soon...</div>
    </div>
</template>

<script>
import CrudIndex from "../../components/crud/index.vue"
import { createField, createColumn } from "../../utils/common"
import { http } from "@/utils/http"
import Paginator from "../../components/other/Paginator.vue"

export default {
    data() {
        return {}
    },
    components: { CrudIndex, Paginator },
    async mounted() {},
    methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.page-title {
    margin-bottom: $sectionGap;
}

/* Placeholder page; tokenized spacing for future content */
.container {
    padding: $cardPaddingY $cardPaddingX;
}
</style>
